import "./StartProject.css";
import { Link } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import animation from "../../../Animation/Start a Project.json";
import Lottie from "react-lottie";
import { Menu } from "../../../Context/MenuOpen/MenuContext";
import { useTranslation } from "react-i18next";
gsap.registerPlugin(ScrollTrigger);

const StartProject = () => {
  const {t , i18n} = useTranslation()
  const contentRef = useRef(null);
  const lottieContainerRef = useRef(null);
  const [playLottie, setPlayLottie] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;

  useGSAP(() => {
    gsap.from(contentRef.current, {
      scrollTrigger: {
        trigger: contentRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power3.out",
    });

    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });

  return (
    <div className="StartProject px-[7vw] py-7">
      <div className="content" ref={contentRef}>
        <p className="py-3 fz-[1.1rem]">{t("Be more creative")}</p>
        <h3>{t("BRING YOUR VISION TO LIFE")}</h3>
        <p>
          {t("From script to screen, we turn ideas into visual stories that speak loud and clear. Whether it’s a reel, a campaign, or a full brand shoot — we create content that connects and performs.")}
        </p>
        <Link className=" btn-hover">
          <span>{t("START PROJECT")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="m85.333 160.617l128-74l.043.025L256 62l-42.667-24.666L42.667 136v197.333L85.333 358zm87.581 23.701l104.419-60.367l104.43 60.373l-104.419 60.368zm-23.581 35.651V346.05L256 407.716v-126.08zm256 126.081l-106.667 61.666V281.649l106.667-61.667zm-128-271.383L448 173.333v197.334l-170.667 98.667l-170.666-98.667V173.333z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="img " ref={lottieContainerRef}>
        {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default StartProject;
